import { useState } from 'react'
import { getAlumnoList } from '../../utils/api/alumnos'
import { Fab, Link } from '@mui/material'
import InformationTable from '../../components/Table/InformationTable'
import { useQuery } from '@tanstack/react-query'
import { useNotification } from '../../context/NotificationManager/NotificationManager'
import TableHeader from '../../components/TableHeader/TableHeader'
import PageLoading from '../../components/PageLoading/PageLoading'
import { textFilter } from '../../utils/table'
import css from './Alumnos.module.css'

const Alumnos = () => {
  const notification = useNotification()

  const [search, setSearch] = useState('')

  const { isLoading, data: alumnoList = [] } = useQuery({
    queryKey: ['alumno', 'list'],
    queryFn: () =>
      getAlumnoList()
        .then(datos => datos)
        .catch(err => {
          notification.error({
            title: 'Error al recuperar los alumnos',
            content: err
          })
          return []
        })
  })

  const filterSearch = alumno => {
    return textFilter({
      object: {
        ...alumno,
        email: (alumno.emails || []).map(e => e.email).join(' '),
        telefono: (alumno.telefonos || []).map(t => t.telefono).join(' ')
      },
      fields: ['nombre', 'telefono', 'email'],
      search: search
    })
  }

  return (
    <PageLoading isLoading={isLoading}>
      <TableHeader
        title='Alumnos activos'
        search={search}
        onSearchChange={e => setSearch(e.target.value)}
      />
      <InformationTable
        details={[
          { title: 'Nombre', key: 'nombre' },
          {
            title: 'Teléfono',
            key: 'telefono',
            visibility: 'lg',
            sortDisabled: true
          },
          {
            title: 'E-mail',
            key: 'email',
            visibility: 'lg',
            sortDisabled: true
          }
        ]}
        data={alumnoList.filter(filterSearch).map(alumno => ({
          nombre: (
            <Link className={css.link} href={`/alumnos/${alumno.id}/ficha`}>
              {alumno.nombre}
            </Link>
          ),
          telefono: alumno.telefonos?.[0]?.telefono || '--',
          email: alumno.emails?.[0]?.email || '--'
        }))}
        isFetching={isLoading}
      />
      <Fab
        className={css.fab}
        color='primary'
        aria-label='add'
        href='/nuevo-alumno'
      >
        <i className='material-icons'>add</i>
      </Fab>
    </PageLoading>
  )
}

export default Alumnos
